module.exports = __webpack_public_path__ + "static/img/bg-es.427d87da.png";